import {
  AfterViewInit,
  Directive,
  effect,
  ElementRef,
  inject, Injector,
  input,
  OnDestroy,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {ABService} from "../services/a-b.service";

@Directive({
  selector: '[hFadeIn]',
})
export class FadeInDirective implements AfterViewInit, OnDestroy {
  /** ms before starting the animation (default 0) */
  public readonly delay = input.required<number>();
  public readonly duration = input<number>(2000);
  private readonly abService = inject(ABService);
  /** class names (optional to override) */
  private readonly startClass = 'fi-start';
  private readonly inClass = 'fi-in';

  private readonly el: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly renderer = inject(Renderer2);
  private readonly injector = inject(Injector);


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private timeoutId: any;
  private done = false;

  ngAfterViewInit(): void {
    this.renderer.removeClass(this.el.nativeElement, this.inClass);
    this.renderer.addClass(this.el.nativeElement, this.startClass);

    effect(() => {
      if (!this.abService.landingPageOption()) {
        return;
      }

      if (this.done) {
        return;
      }
      this.done = true;

      if (!isPlatformBrowser(this.platformId)) {
        this.showImmediately();
        return;
      }

      if(this.abService.landingPageOption() !== 'animated') {
        this.showImmediately();
        return;
      }

      const t = `opacity ${this.duration()}ms ease, transform ${this.duration()}ms ease`;
      this.el.nativeElement.style.transition = t;


      if (this.delay() > 0) {
        this.timeoutId = setTimeout(() => requestAnimationFrame(() => this.play()), this.delay());
      } else {
        // next tick to ensure CSS transition runs
        setTimeout(() => requestAnimationFrame(() => this.el.nativeElement.classList.add(this.inClass)));
      }
    }, {injector: this.injector});

  }

  showImmediately(): void {
    this.renderer.addClass(this.el.nativeElement, this.inClass);
    this.renderer.setStyle(this.el.nativeElement, 'transition', 'none');
  }

  /** manually trigger (if you set delay or want to call from component) */
  play(): void {
    this.renderer.removeClass(this.el.nativeElement, this.startClass);
    this.renderer.addClass(this.el.nativeElement, this.inClass);
  }

  ngOnDestroy(): void {
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }
}
